/**
 * Created by razial on 2026-05-21.
 */

RewardedPromoSource = {
    type: "merge3",

    categories: ["none", "weak", "medium", "whale", "bigwhale"],

    rewards: [
        {
            none: { units: { code: "freechest", stage: 2 } },
            weak: { units: { code: "crystal", stage: 0 } },
            medium: { units: { code: "treasure", stage: 2 } },
            whale: { units: { code: "herochest", stage: 1 } },
            bigwhale: { units: { code: "herochest", stage: 1 } }
        },
        {
            none: { units: { code: "crystal", stage: 0 } },
            weak: { units: { code: "energy", stage: 2 } },
            medium: { units: { code: "crystal", stage: 0 } },
            whale: { units: { code: "crystal", stage: 0, amount: 2 } },
            bigwhale: { units: { code: "crystal", stage: 0, amount: 3 } }
        },
        {
            none: { units: { type: "reschest", stage: 1 } },
            weak: { units: { type: "reschest", stage: 1 } },
            medium: { units: { type: "reschest", stage: 1 } },
            whale: { units: { type: "reschest", stage: 1, amount: 2 } },
            bigwhale: { units: [{ type: "reschest", stage: 1 }, { code: "herochest", stage: 2 }] }
        },
        {
            none: { units: { code: "crystal", stage: 1 } },
            weak: { units: { code: "crystal", stage: 1 } },
            medium: { units: { code: "treasure", stage: 2 } },
            whale: { units: { code: "crystal", stage: 3 } },
            bigwhale: { units: { code: "crystal", stage: 3 } }
        },
        {
            none: { units: { code: "treasure", stage: 2 } },
            weak: { units: { code: "herochest", stage: 1 } },
            medium: { units: { code: "herochest", stage: 2 } },
            whale: { units: [{ type: "reschest", stage: 2 }, { code: "herochest", stage: 2 }] },
            bigwhale: { units: [{ type: "reschest", stage: 1, amount: 2 }, { type: "reschest", stage: 2 }] }
        },
        {
            none: { units: { code: "energy", stage: 2 } },
            weak: { units: { code: "energy", stage: 2, amount: 2 } },
            medium: { units: { code: "crystal", stage: 3 } },
            whale: { units: { code: "crystal", stage: 3, amount: 2 } },
            bigwhale: { units: { code: "crystal", stage: 3, amount: 3 } }
        },
        {
            none: { units: { code: "herochest", stage: 0 } },
            weak: { units: [{ code: "freechest", stage: 2 }, { code: "herochest", stage: 1 }] },
            medium: { units: [{ type: "reschest", stage: 1, amount: 2 }, { code: "herochest", stage: 2 }] },
            whale: { units: [{ type: "reschest", stage: 1, amount: 5 }, { code: "herochest", stage: 2, amount: 5 }] },
            bigwhale: { units: [{ type: "reschest", stage: 2, amount: 5 }, { code: "herochest", stage: 2, amount: 5 }] }
        },
        {
            none: { hard: 200, units: { code: "herochest", stage: 1 } },
            weak: { hard: 600, units: { type: "reschest", stage: 2 } },
            medium: { hard: 600, units: { type: "reschest", stage: 2 } },
            whale: { hard: 1000, units: { type: "reschest", stage: 2, amount: 5 } },
            bigwhale: { hard: 2000, units: { type: "reschest", stage: 2, amount: 7 } }
        }
    ]
};

RewardedPromoSource.expected = function (category) {
    const total = this.rewards.reduce((sum, cell) => sum + (cell[category].hard || 0) + (cell[category].energy || 0), 0);
    // cents, not whole dollars: the unit-heavy tables leave neighbor categories closer than $1 apart
    return Math.round(total * Product.HARD_TO_USD * 100) / 100;
};

RewardedPromoSource.computeExpectedReward = function () {
    return this.expected(this.categories[cleverapps.paymentsHistory.classify()]) || 0;
};

RewardedPromoSource.findCategory = function (value) {
    return this.categories.reduce((best, cat) => (
        Math.abs(this.expected(cat) - value) < Math.abs(this.expected(best) - value) ? cat : best
    ));
};
